/* Premium trending store helpers */
(function () {
  const pad = (n) => String(n).padStart(2, '0');

  /* ---------- Sale countdown (merchant-set end date) ---------- */
  if (!customElements.get('pb-countdown')) {
    customElements.define(
      'pb-countdown',
      class extends HTMLElement {
        connectedCallback() {
          const raw = (this.dataset.end || '').trim().replace(' ', 'T');
          this.end = new Date(raw).getTime();
          if (!raw || isNaN(this.end)) return;
          this.els = {
            d: this.querySelector('[data-d]'),
            h: this.querySelector('[data-h]'),
            m: this.querySelector('[data-m]'),
            s: this.querySelector('[data-s]'),
          };
          this.tick();
          this.timer = setInterval(() => this.tick(), 1000);
        }
        disconnectedCallback() {
          clearInterval(this.timer);
        }
        tick() {
          const diff = this.end - Date.now();
          if (diff <= 0) {
            this.hidden = true;
            clearInterval(this.timer);
            return;
          }
          this.hidden = false;
          const s = Math.floor(diff / 1000);
          this.els.d.textContent = pad(Math.floor(s / 86400));
          this.els.h.textContent = pad(Math.floor((s % 86400) / 3600));
          this.els.m.textContent = pad(Math.floor((s % 3600) / 60));
          this.els.s.textContent = pad(s % 60);
        }
      }
    );
  }

  /* ---------- Delivery estimate ---------- */
  if (!customElements.get('pb-delivery')) {
    customElements.define(
      'pb-delivery',
      class extends HTMLElement {
        connectedCallback() {
          const min = parseInt(this.dataset.min, 10) || 0;
          const max = Math.max(parseInt(this.dataset.max, 10) || 0, min);
          const skipSunday = this.dataset.skipSunday === 'true';
          const fmt = new Intl.DateTimeFormat(undefined, { weekday: 'short', day: 'numeric', month: 'short' });
          const addDays = (n) => {
            const d = new Date();
            let added = 0;
            while (added < n) {
              d.setDate(d.getDate() + 1);
              if (skipSunday && d.getDay() === 0) continue;
              added++;
            }
            return d;
          };
          const range = this.querySelector('[data-range]');
          if (range) {
            range.textContent = min === max ? fmt.format(addDays(min)) : `${fmt.format(addDays(min))} – ${fmt.format(addDays(max))}`;
          }
          const cutoff = parseInt(this.dataset.cutoff, 10) || 0;
          const line = this.querySelector('[data-cutoff-line]');
          if (cutoff > 0 && line) {
            const update = () => {
              const now = new Date();
              const end = new Date();
              end.setHours(cutoff, 0, 0, 0);
              const diff = end - now;
              if (diff <= 0) {
                line.hidden = true;
                return;
              }
              const h = Math.floor(diff / 3600000);
              const m = Math.floor((diff % 3600000) / 60000);
              line.querySelector('[data-left]').textContent = `${h}h ${m}m`;
              line.hidden = false;
            };
            update();
            this.timer = setInterval(update, 30000);
          }
        }
        disconnectedCallback() {
          clearInterval(this.timer);
        }
      }
    );
  }

  /* ---------- Sticky add to cart ---------- */
  if (!customElements.get('pb-sticky-atc')) {
    customElements.define(
      'pb-sticky-atc',
      class extends HTMLElement {
        connectedCallback() {
          this.form = document.getElementById(this.dataset.form);
          this.priceEl = document.getElementById(this.dataset.price);
          this.priceTarget = this.querySelector('[data-sticky-price]');
          this.btn = this.querySelector('[data-sticky-btn]');
          if (!this.form) return;

          const mainBtn = () => this.form.querySelector('[name="add"]');
          const syncPrice = () => {
            if (!this.priceEl || !this.priceTarget) return;
            const container = this.priceEl.querySelector('.price');
            this.priceTarget.innerHTML = container ? container.outerHTML : '';
            const b = mainBtn();
            if (b && this.btn) {
              this.btn.disabled = b.disabled;
              const label = b.querySelector('span');
              if (label) this.btn.textContent = label.textContent.trim();
            }
          };
          syncPrice();
          if (this.priceEl) {
            new MutationObserver(syncPrice).observe(this.priceEl, { childList: true, subtree: true });
          }
          const b = mainBtn();
          if (b) new MutationObserver(syncPrice).observe(b, { attributes: true, childList: true, subtree: true });

          this.btn.addEventListener('click', () => {
            const main = mainBtn();
            if (main && !main.disabled) {
              main.click();
            } else {
              this.form.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
          });

          const target = this.form.closest('.product-form') || this.form;
          const io = new IntersectionObserver(
            ([entry]) => {
              const show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
              this.classList.toggle('is-visible', show);
              this.setAttribute('aria-hidden', String(!show));
              this.btn.tabIndex = show ? 0 : -1;
              document.body.classList.toggle('pb-sticky-on', show);
            },
            { threshold: 0 }
          );
          io.observe(target);
        }
      }
    );
  }
})();
